import {
  RECEIVE_TRAIN_POSITION,
  RECEIVE_NOTIFICATION,
  RECEIVE_TRAIN_DETAIL,
  RECEIVE_LINES,
  RECEIVE_MAINTENANCE,
  RECEIVE_STATION_ID,
  RECEIVE_TRAIN_ICON_SETTINGS,
  CLOSE_TRAIN_MODAL,
  CLOSE_TRANSFER_MODAL,
  CLOSE_TRAIN_OPERATION,
  NEXT_NOTIFICATION,
  LINE_REVERSE,
} from '../actions'

const initialState = {
  lines: [], // TODO: lines はここに置くべきではなかった。あとで直す
  trains: [],
  notifications: [],
  trainIconSettings: {},
  nankai_update_date: null,
  nankai_update_time: null,
  nankai_scheduleTypes: null,
  koya_update_date: null,
  koya_update_time: null,
  koya_scheduleTypes: null,
  showingTrain: null, // TODO: 名前と初期値が良くない気がする
  train_kind_name: null,
  departure_station_name: null,
  arrival_station_name: null,
  station_infos: null,
  showingOperation: false,
  showingNext: false,
  reverseFlag: false,
  maintenance: false,
  station_id: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_MAINTENANCE:
      return {
        ...state,
        maintenance: action.payload.maintenance,
      }
    case RECEIVE_NOTIFICATION:
      return {
        ...state,
        notifications: action.payload.hash_notifications,
      }
    case RECEIVE_LINES:
      return {
        ...state,
        lines: action.payload.lines,
      }
    case RECEIVE_TRAIN_POSITION:
      return {
        ...state,
        trains: action.payload.trains,
        nankai_update_date: action.payload.nankai_update_date,
        nankai_update_time: action.payload.nankai_update_time,
        nankai_scheduleTypes: action.payload.nankai_schedule_types,
        koya_update_date: action.payload.nankai_update_date,
        koya_update_time: action.payload.nankai_update_time,
        koya_scheduleTypes: action.payload.koya_schedule_types
      }
    case RECEIVE_TRAIN_DETAIL:
      return {
        ...state,
        train_kind_name: action.payload.train_kind_name,
        departure_station_name: action.payload.departure_station_name,
        arrival_station_name: action.payload.arrival_station_name,
        station_infos: action.payload.station_infos,
      }
    case RECEIVE_STATION_ID:
      return {
        ...state,
        station_id: action.payload.station_id,
      }
    case RECEIVE_TRAIN_ICON_SETTINGS:
      let conditions = action.payload.conditions.filter( (condition) => {
        const hasCondition = condition.start_at
          || condition.end_at
          || condition.line_kinds 
          || condition.train_kind_ids
          || condition.train_numbers
          || condition.car_numbers
          || condition.required_car_numbers
          || condition.station_start_at
          || condition.station_end_at
        return (condition.icon_url && hasCondition) ? true : false
      })
      
      return {
        ...state,
        trainIconSettings: {
          ...action.payload,
          conditions: conditions
        }
      }
    case CLOSE_TRAIN_MODAL:
      return {
        ...state,
        train_kind_name: null,
        departure_station_name: null,
        arrival_station_name: null,
        station_infos: null,
      }
    case CLOSE_TRANSFER_MODAL:
      return {
        ...state
      }
    case CLOSE_TRAIN_OPERATION:
      return {
        ...state,
        showingOperation: action.showingOperation
      }
    case  NEXT_NOTIFICATION:
      return {
        ...state,
        showingNext: action.showingNext
      }
    case  LINE_REVERSE:
      return {
        ...state,
        reverseFlag: action.reverseFlag
      }
    default:
      return state
  }
}

export default reducer
